import {usePage} from "@inertiajs/vue3";
import {computed} from "vue";

const page = usePage();

const flash = computed(() => (page.props?.flash ?? {}) as Record<string, string | null>);

const error = computed(() => flash.value?.error || null);
const success = computed(() => flash.value?.success || null);
const warning = computed(() => flash.value?.warning || null);

const isVisible = computed(() => {
    return !!(error.value || success.value || warning.value);
})

export const useFlash = () => {
    return {
        flash,
        isVisible,
        error,
        success,
        warning
    };
};
